import { onMounted } from 'vue'

export function useTextareaAutoHeight() {
  const adjustTextareaHeight = (element: HTMLTextAreaElement, baseHeight: number) => {
    element.style.height = `${baseHeight}px`
    const maxHeight = parseInt(getComputedStyle(element).maxHeight, 10) || 220
    element.style.height = `${Math.min(element.scrollHeight, maxHeight)}px`
    element.style.overflowY = element.scrollHeight > maxHeight ? 'auto' : 'hidden'
  }

  onMounted(() => {
    const textareas = document.querySelectorAll<HTMLTextAreaElement>('.textareaAutoHeight')
    textareas.forEach((textarea) => {
      let initialHeight = parseInt(textarea.style.height, 10)
      if (isNaN(initialHeight) || initialHeight <= 0) {
        initialHeight = parseInt(getComputedStyle(textarea).height, 10) || 120
      }

      adjustTextareaHeight(textarea, initialHeight)
      textarea.addEventListener('input', () => adjustTextareaHeight(textarea, initialHeight))
    })
  })
}
